interface FilterPanelContentProps {
  children: React.ReactNode;
}

export const TabContent = ({ children }: FilterPanelContentProps) => {
  return <>{children}</>;
};
